import React from 'react';

import Icon from '../Icon/Icon';

const RefreshIcon = (props) => {
    return (
        <Icon width='32' height='32' {...props}>
            <g clipPath='url(#z3xqtgouva)'>
                <path
                    d='M16 8v4l5.333-5.333L16 1.333v4C10.107 5.333 5.333 10.107 5.333 16c0 2.093.614 4.04 1.654 5.68l1.946-1.947A7.827 7.827 0 0 1 8 16c0-4.413 3.587-8 8-8zm9.013 2.32-1.946 1.947A8.024 8.024 0 0 1 24 16c0 4.413-3.587 8-8 8v-4l-5.333 5.333L16 30.667v-4c5.893 0 10.667-4.774 10.667-10.667 0-2.093-.614-4.04-1.654-5.68z'
                    fill='#34303D'
                />
            </g>
            <defs>
                <clipPath id='z3xqtgouva'>
                    <path fill='#fff' d='M0 0h32v32H0z' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default RefreshIcon;
